<div *ngIf="isLoading">
  <div
    style="position: fixed; z-index: 900; width: 100vw; height: 100vh; opacity: 80; top: 0; left: 0; background: #e8e8e880;">
  </div>
  <mat-spinner class="spinner-center" style="z-index: 1000;"></mat-spinner>
</div>

<div mat-dialog-title>
  รายงานผล
  <div style="float: right; margin-top: -5px;">

    <button mat-icon-button [mat-dialog-close]="true" (click)="closeModal()" style="float: right; margin-top: -6px;">
      <img src="../../../../assets/close-white.png" style="width: 12px;">
    </button>
  </div>
</div>

<mat-dialog-content id="modalMeasureReport" class="mat-typography" style="padding: 0px 3%;">
  <div class="container">
    <div class="row justify-content-center mb-4">
      <div class="col-md-12 col-12 text-center">
        <p class="title text-center my-3" style="font-size: medium;">
          รายงานผลส่งไปทาง E-mail ของท่านแล้ว
          และระบบจะเก็บรายงานผลไว้ภายในระบบ
          ไม่เกิน 45 วันเพื่อความเป็นส่วนตัวของท่าน
        </p>
        <div class="row">
          <div class="col-lg-6 col-md-12 col-sm-12">
            <button (click)="openConsult()" class="btn mt-2"
              style="color: #FFF; font-size: small; background: #0811ba;">
              รับการ Consult เพิ่มเติม
            </button>
          </div>
          <div class="col-lg-6 col-md-12 col-sm-12">
            <button (click)="report()" class="btn btn-success mt-2" style="color: #FFF; font-size: small;">
              ดูรายงานผล
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</mat-dialog-content>
